import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export type OrderSummaryState = {
  data: {
    creditValue: number | null;
  };
};

export const initialState: OrderSummaryState = {
  data: {
    creditValue: null
  }
};

export const slice = createSlice({
  name: 'orderSummary',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setCreditValue: (state, { payload }) => {
      state.data.creditValue = payload;
    }
  }
});

export const { setInitialState, setCreditValue } = slice.actions;
export const selectSlice = (state: RootState) => state[slice.name];
export const selectData = (state: RootState) => selectSlice(state).data;
export const selectCreditValue = (state: RootState) =>
  selectData(state).creditValue;

export default slice.reducer;
